<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
			<div class="card border-0">
			    <div class="card-header h5 bg-transparent border-0">Create a Quote</div>




          <div v-if="section == 0" class="card-body">
            <div class="row">
              <div class="col-12">
                <small>Select the Organization</small>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-3">
              <div v-if="orgListLoad == '0'" class="col-12 d-flex align-items-center justify-content-center">
                <spring-spinner :animation-duration="2000" :size="25" color="#0E1698" /><span class="ml-2">Loading Organizations</span>
              </div>
              <div v-if="orgListLoad == '1'" class="col-12">
                <select type="text" class="form-control" id="orgname" v-model="org_id" @change="checkOrg">
                  <option value="n">Select an Organization</option>
                  <option v-for="(org, index) in orgList" :value="org.id">{{ org.name }}</option>
                </select>
              </div>
            </div>

            <div v-if="orgErrorList.length > 0" class="row">
              <div class="col-12">Unfortunately, this organization is not quotable for the following reason:</div>
              <div v-for="(error, index) in orgErrorList" class="col-12"><i class="fa fa-times text-danger mr-3" aria-hidden="true"></i>{{ error }}</div>
              
            </div>

            <div class="row">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <span></span>
                <span class="font-weight-bold">Step 1 of 4</span>
                <span v-if="sectionCheck == 0"></span>
                <span v-if="sectionCheck == 8"><spring-spinner :animation-duration="2000" :size="25" color="#0E1698" /></span>
                <button v-if="sectionCheck == 1" @click="nextSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-center align-items-center">
                <button @click="cancelQuote" class="btn btn-sm btn-warning">Cancel</button>
              </div>
            </div>
          </div>

          <div v-if="section == 1" class="card-body">
            <div class="row d-flex align-items-center">
              <div class="col-12">
                <small>Select a Contact</small>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-3">
              <div v-if="contactListLoad == '0'" class="col-12">
                <spring-spinner :animation-duration="2000" :size="25" color="#0E1698" style="margin:auto"/>
              </div>
              <div v-if="contactListLoad == '1'" class="col-12">
                <select type="text" class="form-control" id="conname" v-model="contact_id">
                  <option value="n">Select a Contact</option>
                  <option v-for="(contact, index) in contactList" :value="contact.id">{{ contact.f_name }} {{ contact.l_name }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <button @click="prevSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <span class="font-weight-bold">Step 2 of 4</span>
                <button @click="nextSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-center align-items-center">
                <button @click="cancelQuote" class="btn btn-sm btn-warning">Cancel</button>
              </div>
            </div>
          </div>

          <div v-if="section == 2" class="card-body">
            <div class="row d-flex align-items-center">
              <div class="col-12">
                <small>Select a Build</small>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-3">
              <div v-if="buildListLoad == '0'" class="col-12">
                <spring-spinner :animation-duration="2000" :size="25" color="#0E1698" style="margin:auto"/>
              </div>
              <div v-if="buildListLoad == '1'" class="col-12">
                <select type="text" class="form-control" id="conname" v-model="build_id">
                  <option value="n">Select a Build</option>
                  <option v-for="(build, index) in buildList" :value="build.id">{{ build.build_name }}</option>
                </select>
              </div>
            </div>

            <!-- <div v-if="buildListLoad == '1'" class="row d-flex align-items-center mb-3">
              <div class="col-12">
                <small>Select a Quote Format</small>
              </div>
              <div class="col-12">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="type" value="0" >
                  <label class="form-check-label" for="exampleRadios1">
                    Budgetary
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="type" value="1">
                  <label class="form-check-label" for="exampleRadios2">
                    Explanatory
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" v-model="type" value="2" >
                  <label class="form-check-label" for="exampleRadios3">
                    Full
                  </label>
                </div>
              </div>
            </div> -->

            <div class="row">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <button @click="prevSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <span class="font-weight-bold">Step 3 of 4</span>
                <button @click="nextSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-center align-items-center">
                <button @click="cancelQuote" class="btn btn-sm btn-warning">Cancel</button>
              </div>
            </div>
          </div>

          <div v-if="section == 3" class="card-body">
            
            <div v-if="waiting == 0" class="input-group mb-3">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <input type="checkbox" aria-label="Checkbox for following text input" v-model="emailCheck">
                </div>
              </div>
              <div class="form-control">Send quote in email?</div>
            </div>

            <div v-if="emailCheck == false" class="row d-flex align-items-center">
              <div v-if="waiting == 0" class="col-12 d-flex justify-content-between">
                <button @click="prevSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="cancelQuote" class="btn btn-sm btn-warning">Cancel</button>
                <button @click="submitQuote" class="btn btn-sm btn-success">Complete and Save</button>
              </div>
              <div v-if="waiting == 1" class="col-12 d-flex justify-content-center align-items-center">
                <self-building-square-spinner :animation-duration="6000" :size="25" color="#0E1698" /><span class="ml-2">Saving, Please Wait. This may take a minute.</span>
              </div>
            </div>


            <slot v-if="emailCheck == true">

            <div v-if="waiting == 0" class="row">
              <div class="col-12">
                <small>Message the Email</small>
              </div>
            </div>

            <div v-if="waiting == 0" class="row d-flex align-items-center mb-3">
              <div class="col-12">
                <wysiwyg v-model="message" />
              </div>
            </div>

            <div v-if="waiting == 0" class="row d-flex align-items-center mb-3 mt-3">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <span class="h5 font-style-bold">Send to address</span><a v-if="emAddr.length < 3" href="#" @click="addEmAdd" class="small" >Add Address</a>
              </div>
              <div v-for="(em,index) in emAddr" class="col-12">
                <div class="input-group mb-2">
                  <div v-if="emAddr.length > 1" class="input-group-prepend">
                    <button class="btn btn-danger" type="button" @click="removeEmAddr(index)"><i class="fa fa-times" aria-hidden="true"></i></button>
                  </div>
                  <input type="email" class="form-control" placeholder="Send To Address" aria-label="Example text with button addon" v-model="emAddr[index]">
                </div>
              </div>
            </div>

            <div class="row d-flex align-items-center">
              <div v-if="waiting == 0" class="col-12 d-flex justify-content-between">
                <button @click="prevSection" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="cancelQuote" class="btn btn-sm btn-warning">Cancel</button>
                <button @click="submitQuoteAndSend" class="btn btn-sm btn-success">Complete and Send</button>
              </div>
              <div v-if="waiting == 1" class="col-12 d-flex justify-content-center align-items-center">
                <self-building-square-spinner :animation-duration="6000" :size="25" color="#0E1698" /><span class="ml-2">Saving, Please Wait. This may take a minute.</span>
              </div>
            </div>
            </slot>
          </div>

			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>



<script>

import { SpringSpinner } from 'epic-spinners'
import { SelfBuildingSquareSpinner  } from 'epic-spinners'



export default {
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      orgList: [],
      orgListLoad: '0',
      contactList: [],
      contactListLoad: '0',
      buildList: [],
      buildListLoad: '0',
      emailCheck: false,
      waiting: 0,
      sectionCheck: 0,

      orgErrorList: [],

      emAddr: [],

      section: 0,
      message: '',
      type: '0',
      build_id: 'n',
      org_id: 'n',
      contact_id: 'n',

      previewURL: '/utility/user/quote/previewquotepdf/',

    }
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted() {
    this.onOpen();
    this.getOrgList();
    this.getBuildList();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    
    onOpen() {
      var _this = this;
      if(typeof _this.prop3[2] === 'undefined') {
          // does not exist
      }
      else {
        _this.getContactList(_this.prop3[2])
        _this.section = 1;
        _this.org_id = _this.prop3[2]
      }
    },

    getBuildList () {
      var _this = this;
      _this.buildListLoad = '0';
      axios.get('/utility/user/contact/getallbuildsbyuser')
        .then(function (response) {
          var a = response.data.data;
          _this.buildList = a;
          _this.buildListLoad = '1';
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },

    getOrgList () {
      var _this = this;
      _this.orgListLoad = '0';
      axios.get('/utility/user/org/getallorgsbyuser')
        .then(function (response) {
          var a = response.data.data;
          _this.orgList = a;
          _this.orgListLoad = '1';
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },
    
    getContactList(x) {
      var _this = this;
      _this.contactListLoad = '0';
      axios.get('/utility/user/contact/getallcontactsbyorg/' + x)
        .then(function (response) {
          var a = response.data.data;
          _this.contactList = a;
          _this.contactListLoad = '1';
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },

    checkOrg() {
      var _this = this;
      _this.sectionCheck = 8;
      
      axios.get('/utility/user/org/checkhasaddress/' + _this.org_id)
      .then(function (response) {
        var a = response.data.data;
        _this.orgErrorList = a;
        if(_this.orgErrorList.length > 0) {
          _this.sectionCheck = 0;
        } else {
          _this.sectionCheck = 1;
        }
      })
  
        

    },

    nextSection() {
      var _this = this;
      switch(_this.section){
        case 0:
          if(_this.org_id == '' || _this.org_id == null || _this.org_id == 'n' || _this.orgCheck == 1) {
            var msg = "You must make a valid organization choice to proceed.";
            _this.$swal({ type: 'error', title: 'Problem!', text: msg, });
            return false;
          } else {
            _this.getContactList(_this.org_id);
            _this.section = 1;
          }
        break;
        case 1:
          if(_this.contact_id == '' || _this.contact_id == null || _this.contact_id == 'n') {
            var msg = "You must make a valid contact choice to proceed.";
            _this.$swal({ type: 'error', title: 'Problem!', text: msg, });
            return false;
          } else {
            _this.emAddr = [];
            _this.getContactEmail(_this.contact_id);
            _this.section = 2;
          }
        break;
        case 2:
          if(_this.build_id == '' || _this.build_id == null || _this.build_id == 'n') {
            var msg = "You must make a valid build choice to proceed.";
            _this.$swal({ type: 'error', title: 'Problem!', text: msg, });
            return false;
          } 
          if(_this.type == '' || _this.type == null ) {
            var msg = "You must make a valid quote type choice to proceed.";
            _this.$swal({ type: 'error', title: 'Problem!', text: msg, });
            return false;
          } 
          _this.section = 3;          
        break;
      }
    },
    prevSection() {
      var _this = this;
      var x = _this.section;
      _this.section = x - 1;
      // if(_this.section < '0') {
      //   return false;
      // } else {
      //   _this.section = _this.section - '1';
      // }

    },
    getContactEmail(x){
      var _this = this;
      axios.get('/utility/user/contact/getspecificcontact/' + x)
      .then(function (response) {
        var a = response.data.data;
        console.log(a)
        _this.emAddr.push(a.pri_email);
      })
    },

    addEmAdd() {
      var _this = this;
      if(_this.emAddr.length < 3) {
        _this.emAddr.push("");
      }
    },

    removeEmAddr(index){
      var _this = this;
      if(_this.emAddr.length  > 1) {
        _this.emAddr.splice(index, 1);
      } else {
        return false;
      }
    },
    previewQuoteForm() {
       var _this = this
       var text = '<p>As you have not yet saved this quote, it has not recieved a quote number. Therefore it is not complete.</p><p style="font-weight: bold">Do not send this preview quote to a customer.</p>';
      _this.$swal.fire({
        title: 'FYI',
        html: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'I understand!'
      }).then((result) => {
        if (result.value) {
          var pvURL = '/utility/user/quote/previewquotepdf/' + _this.org_id + '/' + _this.contact_id + '/' + _this.build_id;
          window.open(pvURL, '_blank')
        }
      })
     ;
     
    },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    submitQuote() {
      var _this = this;
      _this.$toastr.warning('Saving Quote information.', 'Please wait!')
      // if(_this.message == '' || _this.message == null || _this.message.length < 20) {
      //   var msg = "You must enter some text in the message section.";
      //   _this.$swal({ type: 'error', title: 'Problem!', text: msg, });
      //   return false;
      // }
      _this.waiting = 1;
      axios.post('/utility/user/quote/savecompletequote', {
        message: _this.message,
        type: _this.type,
        build_id: _this.build_id,
        org_id: _this.org_id,
        contact_id: _this.contact_id,
      })
        .then(function (response) {
          var msg = response.data.msg;
          var a = response.data.data;
          _this.$toastr.remove()
          _this.waiting = 0;
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', ['quote-save', a])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
          _this.waiting = 0;
        })
    },

    submitQuoteAndSend() {
      var _this = this;
      _this.$toastr.warning('Saving Quote information.', 'Please wait!')

       var valErrors = [];

      //first remove any emAddr that are empty
      for (i = _this.emAddr.length - 1; i >= 0; --i) {
        if (_this.emAddr[i] == '' || _this.emAddr[i] == null) {
          _this.emAddr.splice(i, 1); // Remove even numbers
        }
      }

      if(_this.emAddr.length < 1 ) { valErrors.push('You must enter at least one valid email address!') }

      //validate email
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      _this.emAddr.forEach(emailValidate);
      function emailValidate(item, index) {
        if(!item.match(mailformat)) { valErrors.push("The email #"+ (index+1) +" you entered is invalid!") }
      } 

      // validate message
      if(_this.message == '' || _this.message == null || _this.message.length < 20) { valErrors.push('The message is required, and must be at least 20 characters!') }

      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.waiting = 1;
      axios.post('/utility/user/quote/sendcompletequote', {
        message: _this.message,
        to_add: _this.emAddr,
        type: _this.type,
        build_id: _this.build_id,
        org_id: _this.org_id,
        contact_id: _this.contact_id,
      })
        .then(function (response) {
          var msg = response.data.msg;
          var a = response.data.data;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.waiting = 0;
          _this.$emit('onSComplete', ['quote-save', a])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
          _this.waiting = 0;
        })
    },

    cancelQuote() {
      var _this = this;
      _this.$emit('onUComplete', ['quote-add'])
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },

  },    
  components:{
    SpringSpinner,
    SelfBuildingSquareSpinner,
  },
  filters: {

  }
}
</script>

